// extracted by mini-css-extract-plugin
export var container = "_3l-0";
export var fullWidth = "_3l-3";
export var lined = "_3l-1";
export var selected = "_3l-4";
export var tab = "_3l-2";